/// <amd-module name="Wiki/ViewCommon/WrappedDialogHelper" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssLayoutManager, WrappedComponent } from "VSS/Platform/Layout";
import { Portal } from "VSSUI/Portal";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

import * as Resources from "Wiki/ViewCommon/Resources";

export const LoadingSpinner = (): JSX.Element => {
    return (
        <Portal>
            <Spinner label={Resources.LoadingSpinnerLabel} className="absolute-fill wd-loading" size={SpinnerSize.large} />
        </Portal>
    );
};

export function showWrappedDialog(pageContext: IVssPageContext, props: { [propertyName: string]: any }, type: string, dependencies: string[]): void {
    const layoutManager = pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
    layoutManager.renderCallout(onDismiss => {
        return (
            <WrappedComponent
                wrappedType={type}
                dependencies={dependencies}
                {...props}
                onDismiss={() => onDismiss()}
                loadingComponent={() => <LoadingSpinner />}
            />
        );
    });
}
